import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "menu-fullscreen-loading"
}
const _hoisted_2 = {
  key: 1,
  class: "band-view"
}
const _hoisted_3 = { class: "band-view-left" }
const _hoisted_4 = { class: "section settings" }
const _hoisted_5 = { class: "section-sub" }
const _hoisted_6 = { class: "section-sub buttons" }
const _hoisted_7 = { class: "section danger" }
const _hoisted_8 = { class: "section-sub buttons" }
const _hoisted_9 = { class: "band-view-right" }
const _hoisted_10 = { class: "section members" }
const _hoisted_11 = { class: "section-sub" }
const _hoisted_12 = { class: "band-submitted-by" }
const _hoisted_13 = { class: "section-sub" }
const _hoisted_14 = { class: "section-sub member-list" }
const _hoisted_15 = { class: "section-sub buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_users_autocomplete = _resolveComponent("users-autocomplete")!
  const _component_x_mark_icon = _resolveComponent("x-mark-icon")!
  const _component_confirm = _resolveComponent("confirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_loading, null, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Loading...", -1)
            ]))]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("legend", null, "Settings", -1)),
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("label", null, "Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSettings && _ctx.saveSettings(...args)), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Save Settings ")
              ])
            ]),
            _createElementVNode("section", _hoisted_7, [
              _cache[8] || (_cache[8] = _createElementVNode("legend", null, "Danger", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.deleteConfirm = true), ["prevent","stop"])),
                  class: "btn-outline btn-danger"
                }, " Destroy Band ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("section", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("legend", null, "Band Members", -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createTextVNode(" Submitted by ", -1)),
                  _createElementVNode("b", null, _toDisplayString(_ctx.band.owner.first_name) + " " + _toDisplayString(_ctx.band.owner.last_name), 1)
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "small" }, " The band owner is implied as a band member so can't be added to the member list ", -1))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Search Users", -1)),
                _createVNode(_component_users_autocomplete, { onPick: _ctx.addMember }, null, 8, ["onPick"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.members, (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: user._id,
                    class: "band-member"
                  }, [
                    _createVNode(_component_x_mark_icon, {
                      onClick: _withModifiers(($event: any) => (_ctx.removeMember(user)), ["prevent","stop"])
                    }, null, 8, ["onClick"]),
                    _createElementVNode("span", null, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveMembers && _ctx.saveMembers(...args)), ["prevent","stop"])),
                  class: "btn-outline"
                }, " Update Members ")
              ])
            ])
          ])
        ])),
    (_ctx.deleteConfirm)
      ? (_openBlock(), _createBlock(_component_confirm, {
          key: 2,
          title: "Destroy Band",
          onOk: _ctx.destroyBand,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteConfirm = false))
        }, null, 8, ["onOk"]))
      : _createCommentVNode("", true)
  ], 64))
}